module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con01"
    }
  }, [_c('h2', {
    staticClass: "contentsHead",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry0"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9781429939973_bm01#bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry1"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/9781429939973_ch01#ch01"
    }
  }, [_vm._v("1 A Dark and Bloody Ground")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry2"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/9781429939973_ch02#ch02"
    }
  }, [_vm._v("2 Two Steps Back")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry3"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/9781429939973_ch03#ch03"
    }
  }, [_vm._v("3 Home Sweet")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry4"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9781429939973_ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 ABC")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry5"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9781429939973_ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Down by the River")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry6"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9781429939973_ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 The Displaced")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry7"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9781429939973_ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Rising Again")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry8"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9781429939973_ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 The Midnight Run")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry9"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9781429939973_ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Brother Against…")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9781429939973_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 What Whispers")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9781429939973_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Digging for More")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9781429939973_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Visiting Unannounced")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9781429939973_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Back to the Battlefield")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9781429939973_ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Aftermath")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry15"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9781429939973_ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Fresh Resolve")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry16"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9781429939973_ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 The Recovery")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry17"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9781429939973_ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Invited")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry18"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9781429939973_ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Winding Down")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4962e7d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429939973_con01.vue
// module id = 72
// module chunks = 0